module.exports = "../img/wezilit-2LRldZL.svg";